import { Item, Picker } from '@adobe/react-spectrum';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const ListingTypePicker = ( {label, options, defaultListingType }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedListingType = searchParams.get('listingType') || defaultListingType;
  const onSelectionChange = (listingType) => {
    const parsedSearch = new URLSearchParams({ listingType });
    setSearchParams(parsedSearch);
  };

  return (
    <Picker
      label={label}
      selectedKey={selectedListingType}
      marginBottom="size-200"
      onSelectionChange={onSelectionChange}
    >
   {options?.map((option) => (
      <Item key={option.key}>{option.label}</Item>
    ))}
    </Picker>
  );
};

export default ListingTypePicker;
